import { Button } from '@cocoonspace/ui/components/button'
import { Card } from '@cocoonspace/ui/components/card'
import { useLingui } from '@lingui/react/macro'
import { ArrowRightIcon } from 'lucide-react'
import { LocalizedLink as Link } from '~/components/localized-link'

import { useFormatPrice } from '~/hooks/use-format-price'
import { useWallet } from '../wallet/use-wallet.hook'

export const WalletInfos = () => {
	const { t } = useLingui()
	const wallet = useWallet()
	const formatPrice = useFormatPrice()

	return (
		<Card className='flex flex-col gap-2 p-4'>
			<div className='font-bold'>{t`Mon solde`}</div>

			<div className='text-primary flex flex-1 items-center justify-center gap-1 text-center text-2xl font-bold'>
				{formatPrice(wallet.data?.amount ?? 0, 'EUR')}
			</div>

			<Button
				variant='link'
				size='sm'
				className='ml-auto gap-1'
				asChild
			>
				<Link href='/account/wallet'>
					{t`Voir le détail`}
					<ArrowRightIcon className='size-3' />
				</Link>
			</Button>
		</Card>
	)
}
